/*eslint-disable no-unused-vars*/
'use strict'
const preloader = {

	fxEnableButton(button) {
		button.classList.contains('js-preloader-file') ? button.style.pointerEvents = 'auto' : button.removeAttribute('disabled')
	},

	fxDisableButton(button) {
		button.classList.contains('js-preloader-file') ? button.style.pointerEvents = 'none' : button.setAttribute('disabled', true)
	},

	fxCreateSpinner(element) {
		const spinner = document.createElement('div')
		spinner.classList.add('btn--loading-spinner')
		element.appendChild(spinner)
	},

	fxRemoveSpinner(element) {
		element.querySelector('.btn--loading-spinner').remove()
	},

	fxPreloaderAdd(element) {
		const button = element.classList.contains('js-preloader-file') ? element : element.querySelector('.js-preloader')
		button.classList.add('btn--loading')
		this.fxDisableButton(button)
		this.fxCreateSpinner(button)
	},

	fxPreloaderRemove(element) {
		const button = element.classList.contains('js-preloader-file') ? element : element.querySelector('.js-preloader')
		button.classList.remove('btn--loading')
		this.fxEnableButton(button)
		this.fxRemoveSpinner(button)
	}
}